import React, { useRef, useState } from 'react';
import { Modal } from '@maxis/components';
import useFetch from '@maxis/client-logic/hooks/useFetch';
import { ContentSection } from '@maxis/components';
import PropTypes from 'prop-types';
import { sanitizeHtml } from '@maxis/client-logic/utils/sanitizeHtml';

const HelpPopup = React.forwardRef((props, ref) => {
    const refPopup = useRef();
    const { request } = useFetch();
    const [contents, setContents] = useState();

    React.useImperativeHandle(ref, () => ({
        showPopup(menuId) {
            pageFunctions.searchData(menuId);
            refPopup.current?.showPopup();
        },
    }));

    const pageFunctions = {
        searchData: async (menuId) => {
            if (menuId) {
                const param = { MENU_ID: menuId };
                const response = await request(`/E3/SYS170/selectDetail`, {
                    method: 'POST',
                    body: param,
                });
                if (response) {
                    setContents(response);
                }
            }
        },
        closePopup: () => {
            refPopup.current?.closePopup();
        },
    };
    const EMPTY_MSG = '등록된 내용이 없습니다.';

    return (
        <Modal
            ref={refPopup}
            defaultTitle={'도움말'}
            closeBtnEvent={() => {
                pageFunctions.closePopup();
            }}
            defaultWidth="800px"
            defaultHeight="600px"
        >
            <div className="headerArr"></div>
            <ContentSection header={contents?.TITLE} height={'100%'}>
                <div className="writerDiv">
                    <span>작성자</span> {contents?.REG_ID}
                </div>
                <div
                    dangerouslySetInnerHTML={{
                        __html: sanitizeHtml(contents?.BODY ?? '<span class="noHelp"/>' + EMPTY_MSG),
                    }}
                    className="boardContent"
                />
            </ContentSection>
        </Modal>
    );
});

HelpPopup.propTypes = {
    callback: PropTypes.func,
};

export default HelpPopup;
